import { render } from "./notas-visual-professor.vue?vue&type=template&id=a2d02bac&scoped=true"
import script from "./notas-visual-professor.vue?vue&type=script&lang=js"
export * from "./notas-visual-professor.vue?vue&type=script&lang=js"

import "./notas-visual-professor.vue?vue&type=style&index=0&id=a2d02bac&lang=css"
import "./notas-visual-professor.vue?vue&type=style&index=1&id=a2d02bac&lang=scss&scoped=true"
import "./notas-visual-professor.vue?vue&type=style&index=2&id=a2d02bac&scoped=true&lang=css"
import "./notas-visual-professor.vue?vue&type=style&index=3&id=a2d02bac&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d02bac"]])

export default __exports__